import React, { Component } from "react";
import { getLanguageMetas, getCurrentLangIndex } from "Pub/js/getMulti";
import { connect } from "react-redux";
import { WidgetSidePath } from "Pub/js/constant";
import WidgetJSLoader from "Pages/NewHome/CreaterForWidget/WidgetJSLoader";
import { checkApp, getSpecialColorList } from "Pages/NewHome/utilService";
import { getWidgetBgImgs } from "Pub/js/backgroundImg";
import AppSide from "./AppSide";

class SideBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            multiLangInfo: {
                langIndex: getCurrentLangIndex(),
                languageMetas: getLanguageMetas()
            },
            widgetSide: null,
            publishModal: {
                dom: null,
                show: false,
                data: null,
                key: this.generatePublishModalKey(),
            },
        }
    }

    componentDidMount() {
        WidgetJSLoader(WidgetSidePath, key => {
            const widgetSide = window[key].default;
            if (widgetSide) {
                this.setState({
                    widgetSide
                });
            }
        });
        const { publishModal } = this.state;
        WidgetJSLoader('/nccloud/resources/business_component/widgetSide/publishModal/main/index.js', key => {
            const publishModalDom = window[key].default;
            if (publishModalDom) {
                this.setState({
                    publishModal: {
                        ...publishModal,
                        dom: publishModalDom
                    }
                });
            }
        });
    }

    // 侧拉值改变
    // sideData: 侧拉数据
    // appData: 应用数据，目前支持更改应用尺寸{ width, height }
    sideComChange(sideData, appData) {
        const { onChange } = this.props;
        onChange(sideData, appData);
    }

    // 侧拉关闭
    sideBoxClose() {
        const { onClose } = this.props;
        onClose && onClose();
    }

    handlePublishWidget = () => {
        const { publishModal } = this.state;
        const { appOption } = this.props;
        const { sideData, parttype } = appOption;
        let publishModalData = {};
        const commonConfig = {
            parttype,
            component_configuration: JSON.stringify(sideData),
            permission_code: sideData.permission_code // 针对于指标卡和单据统计
        }
        let name;
        if (sideData.publicData && sideData.publicData.name) { // 公共配置的
            name = sideData.publicData.name;
        } else if (sideData.hasOwnProperty('name') && typeof sideData.name === 'object') { // 兼容之前部件自己的
            name = sideData.name;
        }
        if (name) { // 多语名称需要处理，传给后台的格式为partsname,partsname2,partsname3等
            for (let k in name) {
                const newK = k.replace('name', 'partname');
                if (name[k].value) {
                    commonConfig[newK] = name[k].value;
                }
            }
        }
        if (checkApp(appOption).isQuickLaunch) { // 快速发起
            publishModalData = {
                config: { ...commonConfig },
                quicklaunch: sideData.cardList
            }
        } else {
            publishModalData = {
                config: { ...commonConfig }
            }
        }
        this.setState({
            publishModal: {
                ...publishModal,
                show: true,
                data: publishModalData
            }
        })
    }

    generatePublishModalKey = () => `publish-modal-${Date.now()}`

    handlePublishModalClose = (publishData) => {
        const { publishModal } = this.state;
        let { key } = publishModal;
        if (publishData) {
            key = this.generatePublishModalKey();
            const { status, app } = publishData;
            if (status === 'Cover') { // 覆盖之后需要更新已经发布的领域部件
                const { onChange, apps = [], appOption } = this.props;
                const { sideData } = appOption;
                const { code } = app;
                const sameCodeApp = apps.find(item => item.appcode === code);
                if (sameCodeApp) {
                    onChange({ ...sideData }, {}, sameCodeApp);
                }
            }
        }
        this.setState({
            publishModal: {
                ...publishModal,
                show: false,
                key,
            }
        })
    }

    render() {
        const { multiLangInfo, widgetSide: WidgetSide, publishModal } = this.state;
        const { dom: PublishModalDom, show: publishModalShow, data: publishModalData, key: publishModalKey } = publishModal;
        const { appOption, relateidObj, sideCom: SideCom, generateNumberName, themeColor } = this.props;
        const { sideData, parttype, iscommon_configuration } = appOption;
        const checkItem = checkApp(appOption);
        const onClose = this.sideBoxClose.bind(this);
        const commonConfigs = {
            bgColors: getSpecialColorList(themeColor, 4, true)
        }
        const commonProps = {
            sideData,
            onChange: this.sideComChange.bind(this),
            onClose,
            editEntry: { // 桌面配置入口
                isWorkbench: relateidObj.type === 'workbench'
            },
            multiLangInfo,
            themeColor
        }
        const { __GlobalConfig__ } = appOption;
        if (__GlobalConfig__) { // 全局配置
            return (
                typeof SideCom === "function" ? <SideCom { ...commonProps } /> : null
            )
        }

        const widgetSideProps = {
            ...commonProps,
            commonConfiguration: {
                ...commonConfigs,
                bgPictures: getWidgetBgImgs(themeColor)
            },
            partType: parttype,
            generateNumberName,
            onPublishWidget: this.handlePublishWidget,
            iscommon_configuration,
            isPublished: checkItem.isPublished
        }
        const appSideProps = {
            ...commonProps,
            // commonConfiguration: {
            //     ...commonConfigs,
            //     bgPictures: getAppBgImgs(themeColor)
            // },
            // iscommon_configuration: true // 强制使用公共配置能力
        }
        return (
            checkItem.isWidget
            ?
                <React.Fragment>
                    {
                        typeof SideCom === "function"
                        ?
                        <SideCom { ...widgetSideProps } />
                        :
                            typeof WidgetSide === 'function'
                            ?
                            <WidgetSide
                                maskClose={onClose}
                                onClose={onClose}
                                widgetProps={widgetSideProps}
                            />
                            :
                            null
                    }
                    {
                        typeof PublishModalDom === 'function'
                        ?
                        <PublishModalDom
                            key={publishModalKey}
                            show={publishModalShow}
                            onClose={this.handlePublishModalClose}
                            widget={{ ...appOption }}
                            publishData={publishModalData}
                        />
                        :
                        null
                    }
                </React.Fragment>
            :
                checkItem.isApp ? <AppSide { ...appSideProps } /> : null
        )
    }
};

export default connect(
    (state) => ({
        themeColor: state.appData.themeColor
    }),
    {}
)(SideBox);